/** Shared membership tier visual tokens (avatar rings, fonts). */

export type MembershipTierId = 'bronze' | 'silver' | 'gold';

export type MembershipTierChrome = {
  id: MembershipTierId;
  label: string;
  /** Premium SaaS wordmark font */
  fontFamily: string;
  ringFrom: string;
  ringVia: string;
  ringTo: string;
  glow: string;
  track: string;
  text: string;
  wash: string;
};

/** Unified premium SaaS typeface for all tier wordmarks */
export const MEMBERSHIP_PREMIUM_FONT =
  '"Sora", "Plus Jakarta Sans", "Inter", system-ui, sans-serif';

export const MEMBERSHIP_TIER_CHROME: Record<MembershipTierId, MembershipTierChrome> = {
  bronze: {
    id: 'bronze',
    label: 'Bronze',
    fontFamily: MEMBERSHIP_PREMIUM_FONT,
    ringFrom: '#ffd4a8',
    ringVia: '#c46a28',
    ringTo: '#7a3a12',
    glow: 'rgba(196, 106, 40, 0.55)',
    track: 'rgba(180, 90, 35, 0.55)',
    text: '#9a5520',
    wash: 'rgba(196, 122, 58, 0.12)',
  },
  silver: {
    id: 'silver',
    label: 'Silver',
    fontFamily: MEMBERSHIP_PREMIUM_FONT,
    ringFrom: '#ffffff',
    ringVia: '#8fa3bc',
    ringTo: '#3d4f66',
    glow: 'rgba(90, 120, 160, 0.5)',
    track: 'rgba(70, 95, 125, 0.5)',
    text: '#45566b',
    wash: 'rgba(95, 113, 136, 0.12)',
  },
  gold: {
    id: 'gold',
    label: 'Gold',
    fontFamily: MEMBERSHIP_PREMIUM_FONT,
    ringFrom: '#fff4b0',
    ringVia: '#f0c020',
    ringTo: '#b8860b',
    glow: 'rgba(240, 192, 32, 0.65)',
    track: 'rgba(200, 150, 20, 0.55)',
    text: '#8f6a0f',
    wash: 'rgba(224, 177, 42, 0.14)',
  },
};

export function getMembershipTierChrome(
  tier: MembershipTierId | string | undefined | null
): MembershipTierChrome | null {
  if (tier === 'bronze' || tier === 'silver' || tier === 'gold') {
    return MEMBERSHIP_TIER_CHROME[tier];
  }
  return null;
}

export function membershipTierLabelSx(tier: MembershipTierId): Record<string, unknown> {
  const c = MEMBERSHIP_TIER_CHROME[tier];
  return {
    fontFamily: c.fontFamily,
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    fontSize: 11,
    color: c.text,
    bgcolor: c.wash,
  };
}
